import { render, staticRenderFns } from "./BenefitWithdraw.vue?vue&type=template&id=5971c15f&scoped=true&"
import script from "./BenefitWithdraw.vue?vue&type=script&lang=js&"
export * from "./BenefitWithdraw.vue?vue&type=script&lang=js&"
import style0 from "./BenefitWithdraw.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BenefitWithdraw.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./BenefitWithdraw.vue?vue&type=style&index=2&id=5971c15f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5971c15f",
  null
  
)

export default component.exports